export function getEnv() {
    let envLocation = window.location.origin;

    switch (envLocation) {

        case "http://localhost:3000":
            // return {
            //     ENDPOINT: 'http://localhost:2001',
            //     KEYCLOAK_URL: 'http://localhost:8081',
            //     REALM: 'ApesalliRealm',
            //     CLIENT_ID: 'ApesalliClient',
            //     CLIENT_SECRET: 'bdnVrqUz2tJb1imWdd8N6eCNmREl8p30',
            //     ENVIRONMENT: 'development',
            //     DEBUG_MODE: true,
            //     LOG_LEVEL: 'debug',
            //     AUTH_METHOD: 'keycloak' // jwt or 'keycloak'
            // }
            // case "http://localhost:3000":
            // return {
            //     ENDPOINT: 'http://4.155.100.20',
            //     KEYCLOAK_URL: 'http://4.155.100.20',
            //     REALM: 'ApesalliRealm',
            //     CLIENT_ID: 'ApesalliClient',
            //     CLIENT_SECRET: 'aM5ytjaHsCCG8QzEy3CW6EtoOsxwKyOA',
            //     ENVIRONMENT: 'development',
            //     DEBUG_MODE: true,
            //     LOG_LEVEL: 'debug',
            //     AUTH_METHOD: 'keycloak' // jwt or 'keycloak'
            // }
            // report.apesalli.lk


            return {
                ENDPOINT: 'https://report.apesalli.lk',
                KEYCLOAK_URL: 'https://report.apesalli.lk',
                REALM: 'ApesalliRealm',
                CLIENT_ID: 'ApesalliClient',
                CLIENT_SECRET: 'aM5ytjaHsCCG8QzEy3CW6EtoOsxwKyOA',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // jwt or 'keycloak'

            }

        case "https://report.apesalli.lk":
            return {
                ENDPOINT: 'https://report.apesalli.lk',
                KEYCLOAK_URL: 'https://report.apesalli.lk',
                REALM: 'ApesalliRealm',
                CLIENT_ID: 'ApesalliClient',
                CLIENT_SECRET: 'aM5ytjaHsCCG8QzEy3CW6EtoOsxwKyOA',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // jwt or 'keycloak'

            }
        case "http://4.155.100.20":
            return {
                ENDPOINT: 'http://4.155.100.20',
                KEYCLOAK_URL: 'http://4.155.100.20',
                REALM: 'ApesalliRealm',
                CLIENT_ID: 'ApesalliClient',
                CLIENT_SECRET: 'aM5ytjaHsCCG8QzEy3CW6EtoOsxwKyOA',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // jwt or 'keycloak'
            }

        case "http://localhost:3001":
            return {
                ENDPOINT: 'https://demo.safetysync.co',
                KEYCLOAK_URL: 'http://localhost:8080',
                REALM: 'sri-lanka-health',
                CLIENT_ID: 'dli_client_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'jwt' // jwt or 'keycloak'
            }

        default:
            return {
                ENDPOINT: 'http://47.130.168.168',
                KEYCLOAK_URL: 'http://47.130.168.168/auth',
                REALM: 'ApesalliRealm',
                CLIENT_ID: 'ApesalliClient',
                CLIENT_SECRET: 'aM5ytjaHsCCG8QzEy3CW6EtoOsxwKyOA',
                ENVIRONMENT: 'production',
                DEBUG_MODE: false,
                LOG_LEVEL: 'error',
                AUTH_METHOD: 'keycloak' // jwt or 'keycloak'
            }
    }
}

// Helper function to get environment variable with fallback
export function getEnvVar(key, defaultValue = '') {
    const env = getEnv();
    return env[key] || defaultValue;
}

// Helper function to check if we're in development mode
export function isDevelopment() {
    return getEnv().ENVIRONMENT === 'development';
}

// Helper function to check if debug mode is enabled
export function isDebugMode() {
    return getEnv().DEBUG_MODE === true;
}